import moment from 'moment';
import { openPrintWindow, escapeHtml } from '../MedicineOrders/printDispenseAuthorization';
import { buildMinistryPrintHtml } from '../../Shared/printLayout';

function fmtDate(v) {
    if (!v) return '—';
    try { return moment(v).format('YYYY/MM/DD HH:mm'); } catch { return '—'; }
}

export function buildPatientDispenseHtml(detail) {
    const lines = (detail.lines || []).map((line, index) => `
        <tr class="${index % 2 === 0 ? 'bg-gray-striped-1' : 'bg-gray-striped-2'}"><td>${index + 1}</td><td>${escapeHtml(line.productName || '')}</td><td>${escapeHtml(line.quantityText || String(line.quantityBase || 0))}</td><td>${escapeHtml(line.note || '—')}</td></tr>
    `).join('');

    const infoHtml = `
        <div class="col-6">
          <table class="table table-sm table-bordered mb-2 meta-table">
            <tbody>
              <tr class="bg-gray-striped-1"><th>اسم المريض</th><td>${escapeHtml(detail.patientName || '—')}</td></tr>
              <tr class="bg-gray-striped-2"><th>${escapeHtml(detail.identifierKindLabel || 'رقم وطني')}</th><td>${escapeHtml(detail.nationalNo || '—')}</td></tr>
              <tr class="bg-gray-striped-1"><th>المرفق</th><td>${escapeHtml(detail.branchName || '—')}</td></tr>
            </tbody>
          </table>
        </div>
        <div class="col-6">
          <table class="table table-sm table-bordered mb-2 meta-table">
            <tbody>
              <tr class="bg-gray-striped-1"><th>القسم</th><td>${escapeHtml(detail.departmentName || '—')}</td></tr>
              <tr class="bg-gray-striped-2"><th>الحالة</th><td>${escapeHtml(detail.statusLabel || '—')}</td></tr>
              <tr class="bg-gray-striped-1"><th>تاريخ الصرف</th><td>${escapeHtml(fmtDate(detail.createdOn))} - ${escapeHtml(detail.createdByName || '—')}</td></tr>
            </tbody>
          </table>
        </div>`;

    const cancelledHtml = Number(detail.status) === 9
        ? `<div class="section-title">فاتورة ملغاة</div>
           <table class="table table-sm table-bordered">
             <tbody>
               <tr><th style="width:25%">تاريخ الإلغاء</th><td>${escapeHtml(fmtDate(detail.cancelledOn))}</td></tr>
               <tr><th>بواسطة</th><td>${escapeHtml(detail.cancelledByName || '—')}</td></tr>
               <tr><th>السبب</th><td>${escapeHtml(detail.cancelReason || '—')}</td></tr>
             </tbody>
           </table>`
        : '';

    const bodyHtml = `
      <table class="table table-sm table-bordered text-center border border-dark align-middle mt-1">
        <thead>
          <tr class="bg-gray"><th>#</th><th>الصنف</th><th>الكمية المصروفة</th><th>ملاحظة</th></tr>
        </thead>
        <tbody>${lines || '<tr><td colspan="4" class="text-center">لا توجد أصناف</td></tr>'}</tbody>
      </table>
      ${detail.note ? `<div class="mt-1"><strong>ملاحظة:</strong> ${escapeHtml(detail.note)}</div>` : ''}
      ${cancelledHtml}`;

    const signaturesHtml = `
        <div class="col-4"><p><strong>الصيدلي المسؤول</strong><br/>الاسم: ............................<br/>التوقيع: ............................</p></div>
        <div class="col-4"><p><strong>المريض / المستلم</strong><br/>الاسم: ............................<br/>التوقيع: ............................</p></div>
        <div class="col-4"><p><strong>ختم القسم</strong><br/>الاسم: ............................<br/>التوقيع: ............................</p></div>`;

    return buildMinistryPrintHtml({
        title: 'فاتورة صرف دواء لمريض',
        docRef: detail.code || detail.id || '',
        infoHtml,
        bodyHtml,
        signaturesHtml,
        footerSummary: 'وثيقة صرف دواء لمريض من رصيد القسم، تُحفظ في ملف المريض وتُعتمد مرجعاً لحركة المخزون.',
        footerMeta: `رقم الفاتورة: <strong>${escapeHtml(detail.code || String(detail.id || ''))}</strong>`
    });
}

export function printPatientDispense(detail) {
    return openPrintWindow(buildPatientDispenseHtml(detail));
}
